export default function MediaSection() {
  const items = [
    {
      title: '《长安十二时辰》第二季',
      desc: '古装悬疑巨制回归，张小敬再度出山破局，高能剧情全程无尿点',
      tag: '热播中',
      img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20scene%20with%20dramatic%20lighting%2C%20historical%20drama%20atmosphere%2C%20warm%20amber%20and%20dark%20tones%2C%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20no%20text%20overlay%2C%20mysterious%20moody%20visual%2C%20Tang%20dynasty%20style%20architecture&width=600&height=340&seq=media-01&orientation=landscape',
    },
    {
      title: '《流浪地球3》院线同步',
      desc: '国产科幻巅峰续作，太阳系危机再临，人类命运共同体最终抉择',
      tag: '新上线',
      img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20scene%20with%20dramatic%20lighting%2C%20dark%20cosmic%20background%2C%20cinematic%20visual%2C%20planet%20and%20spaceship%20elements%2C%20warm%20orange%20accents%20on%20dark%20blue%2C%20epic%20movie%20atmosphere%2C%20no%20text&width=600&height=340&seq=media-02&orientation=landscape',
    },
    {
      title: '《狂飙》未删减完整版',
      desc: '年度现象级扫黑剧，张译张颂文演技炸裂，豆瓣9.1分口碑封神',
      tag: '高分推荐',
      img: 'https://readdy.ai/api/search-image?query=Dark%20urban%20crime%20drama%20visual%20with%20noir%20lighting%2C%20atmospheric%20city%20night%20scene%2C%20gritty%20realistic%20tone%2C%20Chinese%20modern%20city%20backdrop%2C%20cinematic%20composition%2C%20warm%20street%20lights%20on%20dark%20background%2C%20film%20poster%20style%2C%20no%20text&width=600&height=340&seq=media-03&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            全网热播大剧一站聚合，极速高清不卡顿，秒开即播随心追
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/50 cursor-pointer transition-all duration-300 hover:border-primary-500/30"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-primary-500 text-foreground-50 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-foreground-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-100 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}